<!-- 最热资讯：最热+标题+日期 -->
<template>
<div class="info-block">
  <router-link :to="'/hyzx/details/'+info.id" class="info-block-a" target="_blank">
    <div class="title"><span>最热|</span>{{info.title.length>titleLength?(info.title.substring(0,titleLength)+'...'):info.title}}</div>
    <div class="date">{{info.create_time}}</div>
  </router-link>
</div>
</template>
<script>
export default {
  name: 'InfoBlock12',
  props: {
    info: {
      type: Object,
      default: {}
    },
    titleLength:{
      type:Number,
      default:30
    },
    labelLength:{
      type:Number,
      default:28
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:border-box;
  height:80px;
  width:100%;
  padding:0px 2px 0px 2px;
  margin-bottom:10px;
  border-bottom:1px solid #ddd;
  background-color: #fff;
  background-size: 120px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  //border:1px solid #eee;
  color:var(--color6);
  //box-shadow:0px 0px 1px 1px orange;
}

.info-block .info-block-a:hover > .title{
  color:var(--color6);
}

.info-block-a .title{
  position:relative;
  width: 100%;
  height:50px;
  font-size:14px;
  font-weight:400;
  color:#515151;
  line-height:24px;
  text-align:left;
}

.info-block-a .title span{
  font-size:14px;
  color:var(--color6);
  letter-spacing:3px;
}

.info-block-a .date{
  position:relative;
  width: 100%;
  padding-right:10px;
  font-size:12px;
  color:#888888;
  line-height:20px;
  text-align:left;
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock12.vue